/* =====================================================================
 * @auw/tenant — Specialized agents resolver.
 *
 * Reads the tenant manifest's optional `specializedAgents` list and
 * returns the user-visible subset (entries whose `enabled` is not
 * explicitly `false`). Consumers — currently the main sidebar —
 * render an empty section when the result is empty so disabling all
 * entries cleanly removes the "전문 에이전트" group from the UI.
 *
 * Kept as a tiny standalone helper so the sidebar can subscribe via
 * `useMemo(() => resolveSpecializedAgents(tenant), [tenant])` and
 * future surfaces (e.g. a search palette) can share the exact same
 * visibility rule without re-implementing the gate.
 * ===================================================================== */

import type { TenantManifest, TenantSpecializedAgent } from './types';

const EMPTY: readonly TenantSpecializedAgent[] = [];

export function resolveSpecializedAgents(
  manifest: TenantManifest,
): readonly TenantSpecializedAgent[] {
  const entries = manifest.specializedAgents;
  if (!entries || entries.length === 0) return EMPTY;
  return entries.filter((entry) => entry.enabled !== false);
}
